/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_EDITUSERDATA, EDITUSERDATA_RECEIVED } = constants.EditUserdataConstants;

export default {
  REQUEST_EDITUSERDATA,
  EDITUSERDATA_RECEIVED,

  requestEditUserData: payload => ({
    type: REQUEST_EDITUSERDATA,
    payload
  }),
  EditUserDataReceived: () => ({
    type: EDITUSERDATA_RECEIVED
  })
};
